import Protobuf from "pbf";
import {VectorTile} from "@mapbox/vector-tile";
import {fromVectorTileJs} from "@maplibre/vt-pbf";

// Minimum amount of pictures in a tile to consider it "crowded"
const CROWDED_TILE_SIZE = 5000;

/**
 * PanoraMap Protocol adds a new URI scheme "panora://" (or "panoras://") to MapLibre.
 * It allows adding custom information on top of existing Panoramax Vector Tiles.
 * @class Panoramax.utils.PanoraMapProtocol
 * @typicalname panoraMapProtocol
 */
export default class PanoraMapProtocol {
	/**
	 * Get a single tile
	 * @param {object} params MapLibre parameters 
	 * @param {AbortController} abort The abort signal handler
	 * @returns {object} The tile, as expected by MapLibre
	 * @memberof Panoramax.utils.PanoraMapProtocol#
	 */
	tile() {
		return (params, abort) => {
			abort = abort || new AbortController();
			const url = params.url.replace(/^panora/, "http");
			return fetch(url, { signal: abort.signal })
				.then((response) => response.arrayBuffer())
				.then((data) => new VectorTile(new Protobuf(data)))
				.then((tile) => {
					// Skip process if pictures are not available
					if(!tile.layers.pictures || tile.layers.pictures.length >= CROWDED_TILE_SIZE) { return tile; }
					
					Object.values(tile.layers).forEach(layer => {
						const oldFeat = layer.feature.bind(layer);
						layer.feature = (index) => {
							const feature = oldFeat(index);
							// Mark tile as "uncrowded"
							feature.properties.uncrowded = true;
							return feature;
						};
					});
					
					return tile;
				})
				.then((tile) => fromVectorTileJs(tile).buffer)
				.then((data) => ({ data }));
		};
	}
}